import { z } from "zod";
import { ShadowLedgerEntryStatus, ShadowLedgerEntryType } from "../schemas";

const currency = z.string().regex(/^[A-Z]{3}$/);
export const FinanceLedgerQuerySchema = z.object({
  limit: z.number().int().min(1).max(100).default(25),
  offset: z.number().int().min(0).max(100_000).default(0),
  q: z.string().trim().max(200).default(""),
  status: z
    .union([ShadowLedgerEntryStatus, z.literal("ALL")])
    .default("CONFIRMED"),
  type: z.union([ShadowLedgerEntryType, z.literal("ALL")]).default("ALL"),
  currency: currency.optional(),
  due: z
    .enum(["all", "past", "today", "next7", "later", "undated"])
    .default("all"),
});
export type FinanceLedgerQuery = z.infer<typeof FinanceLedgerQuerySchema>;
export const FinanceLedgerRecordSchema = z.object({
  id: z.string().min(1),
  sourceDocumentId: z.string().nullable(),
  documentNumber: z.string().nullable(),
  type: ShadowLedgerEntryType,
  status: ShadowLedgerEntryStatus,
  amount: z.number().finite().nullable(),
  currency: currency.nullable(),
  dueDate: z.string().nullable(),
  counterpartyName: z.string().nullable(),
  description: z.string().nullable().optional(),
});
export type FinanceLedgerRecord = z.infer<typeof FinanceLedgerRecordSchema>;
export const FinanceLedgerPageSchema = z.object({
  data: z.array(FinanceLedgerRecordSchema),
  pagination: z.object({
    limit: z.number().int().min(1).max(100),
    offset: z.number().int().min(0).max(100_000),
    total: z.number().int().nonnegative(),
    hasMore: z.boolean(),
  }),
  summary: z.array(
    z.object({
      currency: currency.nullable(),
      type: ShadowLedgerEntryType,
      status: ShadowLedgerEntryStatus,
      count: z.number().int().positive(),
      amount: z.number().finite().nullable(),
      missingAmountCount: z.number().int().nonnegative(),
    }),
  ),
  asOf: z.string().datetime(),
});
export type FinanceLedgerPage = z.infer<typeof FinanceLedgerPageSchema>;
